import { render } from "./AppCurrencyInput.vue?vue&type=template&id=0a395dbc&scoped=true"
import script from "./AppCurrencyInput.vue?vue&type=script&lang=js"
export * from "./AppCurrencyInput.vue?vue&type=script&lang=js"

import "./AppCurrencyInput.vue?vue&type=style&index=0&id=0a395dbc&scoped=true&lang=css"

import exportComponent from "/home/runner/work/adaptif-frontend/adaptif-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a395dbc"]])

export default __exports__